import styled from 'styled-components'

export const Wrapper = styled.div`
  .suggestion-list-header {
    box-sizing: border-box;
    padding-bottom: 5px;
  }

  .production-plan-title{
    font-style: normal;
    font-weight: var(--font-weight-semibold);
    font-size: 11px;
    line-height: 12px;
    color: #9AA4AD;
    text-transform: uppercase;
  }

  .production-plan-content{
    font-style: normal;
    font-weight: var(--font-weight-semibold);
    font-size: 14px;
    line-height: 15px;
    color: var(--color-contrast-brand);
  }

  border-bottom: ${props => !props.itemExpanded ? '1px solid #EDEEEE' : '1px none #EDEEEE'};
  margin-bottom: 10px;
`

export const TitlesWrapper = styled.div`
  width: calc(100% - 50px);
  display: flex;
  flex-direction: column;

  padding: 0px 5px;

  span:last-child{
    padding-top: 5px;
  }
`

export const ContentWrapper = styled.div`
  display: ${props => props.itemExpanded ? 'flex' : 'none'};
  padding: 0 5px;

  .content-row{
    border-top: 1px solid #EDEEEE;
    width: 100%;
    padding-bottom: 10px;
  }

  .content-col{
    border-bottom: 1px solid #EDEEEE;
    padding-bottom: 5px;
  }

  .supplier-title{
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 14px;
    color: var(--color-action-default);

    white-space: normal;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const InfosWrapper = styled.div`
  display: flex;
  flex-direction: column;

  span{
    margin: 0px;
    padding: 10px 5px 0px 0px;
  }
`
